function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.875 7.875C17.1797 7.875 17.4434 7.98633 17.666 8.20898C17.8887 8.43164 18 8.69531 18 9C18 9.30469 17.8887 9.56836 17.666 9.79102C17.4434 10.0137 17.1797 10.125 16.875 10.125H10.125V16.875C10.125 17.1797 10.0137 17.4434 9.79102 17.666C9.56836 17.8887 9.30469 18 9 18C8.69531 18 8.43164 17.8887 8.20898 17.666C7.98633 17.4434 7.875 17.1797 7.875 16.875V10.125H1.125C0.820311 10.125 0.556642 10.0137 0.333984 9.79102C0.111327 9.56836 0 9.30469 0 9C0 8.69531 0.111327 8.43164 0.333984 8.20898C0.556642 7.98633 0.820311 7.875 1.125 7.875H7.875V1.125C7.875 0.820311 7.98633 0.556642 8.20898 0.333984C8.43164 0.111327 8.69531 0 9 0C9.30469 0 9.56836 0.111327 9.79102 0.333984C10.0137 0.556642 10.125 0.820311 10.125 1.125V7.875H16.875Z"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.ec263871.svg";
export { ForwardRef as ReactComponent };